// TODO: Move this icon to @raydiant/raydial as a proper icon component
import { FC, SVGProps } from 'react';

interface ScheduleActiveIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

const ScheduleActiveIcon: FC<ScheduleActiveIconProps> = ({
  size = 16,
  color = '#058A82',
  style,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginLeft: 2, ...style }}
      {...props}
    >
      <path
        d="M14 6C9.58125 6 6 9.58125 6 14C6 18.4187 9.58125 22 14 22C14.0156 22 14.0312 22 14.0437 22C13.825 21.525 13.6688 21.0187 13.5813 20.4875C10.1875 20.2719 7.5 17.45 7.5 14C7.5 10.4094 10.4094 7.5 14 7.5C17.45 7.5 20.2719 10.1875 20.4875 13.5813C21.0187 13.6688 21.525 13.8281 22 14.0437C22 14.0281 22 14.0125 22 14C22 9.58125 18.4187 6 14 6ZM14 9C13.5844 9 13.25 9.33437 13.25 9.75V14C13.25 14.25 13.375 14.4844 13.5844 14.625L14.9812 15.5562C15.3219 15.1656 15.7125 14.8187 16.1438 14.5281L14.75 13.6V9.75C14.75 9.33437 14.4156 9 14 9ZM19.5 15C17.0156 15 15 17.0156 15 19.5C15 21.9844 17.0156 24 19.5 24C21.9844 24 24 21.9844 24 19.5C24 17.0156 21.9844 15 19.5 15ZM20.5969 17.7063C20.6937 17.5719 20.8469 17.5 21 17.5C21.1031 17.5 21.2031 17.5312 21.2938 17.5969H21.2969C21.5188 17.7594 21.5688 18.0719 21.4062 18.2937L19.4062 21.0438C19.3188 21.1625 19.1875 21.2344 19.0406 21.2469C19.025 21.2469 19.0125 21.25 18.9969 21.25C18.8656 21.25 18.7375 21.1969 18.6469 21.1031L17.3969 19.8531L17.3313 19.775C17.2031 19.5812 17.2281 19.3188 17.3969 19.1469C17.4938 19.0469 17.6219 19 17.75 19C17.8469 19 17.9406 19.0281 18.025 19.0813L18.1031 19.1469L18.9406 19.9812L20.5969 17.7063Z"
        fill={color}
      />
    </svg>
  );
};

export default ScheduleActiveIcon;
